
const calibrationManifest = [
  {
  activityType: "dyslexia",
  type: "dyslexia",
  locale: "en-us",
  sequence: "CONTINUE",
  status: "ASSIGNED",
  storyId: '0ce26380-ce9b-11ee-82ab-e5e4c02653b7',
  activity: [ ],
  tags: ["NO_QA","NO_EDM","NO_SCALING"],
  isCalibration: true
  },
  {
    activityType: "spelling",
    type: "spelling",
    locale: "en-us",
    sequence: "CONTINUE",
    status: "ASSIGNED",
    storyId: 'ababb480-51c7-11ea-81a8-5f91baaf2e5c',
    activity: [ ],
    tags: ["NO_QA","NO_EDM","NO_SCALING"],
    isCalibration: true
  },
  {
    activityType: "vocabularyScreener",
    type: "vocabularyScreener",
    locale: "en-us",
    sequence: "CONTINUE",
    status: "ASSIGNED",
    storyId: '116fc8f0-ce9d-11ee-82ab-e5e4c02653b7',
    activity: [ ],
    tags: ["NO_QA","NO_EDM","NO_SCALING"],
    isCalibration: true
  },
  {
    activityType: "listeningComprehension",
    type: "listeningComprehension",
    locale: "en-us",
    sequence: "CONTINUE",
    status: "ASSIGNED",
    storyId: 'd9edd0a0-ce9e-11ee-82ab-e5e4c02653b7',
    activity: [ ],
    tags: ["NO_QA","NO_EDM","NO_SCALING"],
    isCalibration: true
  },
  {
    activityType: "assessment",
    type: "assessment",
    locale: "en-us",
    sequence: "CONTINUE",
    status: "ASSIGNED",
    storyId: '423e0ce0-5114-11ea-a6af-f998aa9aea1a',
    activity: [ ],
    tags: ["NO_QA","NO_EDM","NO_SCALING"],
    isCalibration: true
  },
  {
    activityType: "readingComprehension",
    type: "readingComprehension",
    locale: "en-us",
    sequence: "CONTINUE",
    status: "ASSIGNED",
    storyId: '75e83985-cfc6-48a3-8d06-e5eff2b87ceb',
    activity: [ ],
    tags: ["NO_QA","NO_EDM","NO_SCALING"],
    isCalibration: true
  },
];

export function getCalibrationAssignment(grade,assignment){
  //Don't transform the assignment if it's outside the range of grades we have
  if((grade !== 3) || !assignment) return assignment;

  //Create the manifest for the calibration assignment
  let newAssignment = JSON.parse(JSON.stringify(assignment))
  newAssignment.manifest = calibrationManifest;
  newAssignment.manifest.forEach((activity)=>{
    const assignmentActivity = assignment.manifest.find((a)=>a.type === activity.type);
    activity.status = assignmentActivity ? assignmentActivity.status : "ASSIGNED";
  });
  return newAssignment;
}

export function getScreenerOverrides(grade){
  if(grade !== 3) return {};

  //Walk the calibration manifest and return the screener overrides
  let overrides = {};
  calibrationManifest.forEach((activity)=>{
    overrides[activity.type] = activity.storyId;
  });
  return overrides;
}